import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import FooterPage from "../FooterPage";

const GetStarted = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [subscribed, setSubscribed] = useState(false);

  const handleSubscribe = () => {
    if (email) { setSubscribed(true); }
  };

  return (
    <div>
      <section className="section px-6 pb-16 max-w-7xl mx-auto">
        <div
          className="rounded-3xl overflow-hidden relative"
          style={{
            background: "linear-gradient(135deg, rgba(82,198,168,0.08) 0%, rgba(79,142,247,0.08) 100%)",
            border: "1px solid rgba(82,198,168,0.2)",
          }}
        >
          {/* Top glow */}
          <div
            className="absolute"
            style={{
              top: "-60px", left: "50%", transform: "translateX(-50%)",
              width: "500px", height: "300px",
              background: "radial-gradient(ellipse, rgba(82,198,168,0.15), transparent 70%)",
            }}
          />

          <div className="relative z-10 p-12 lg:p-20">
            <div className="max-w-3xl mx-auto text-center space-y-8">
              <div className="badge inline-flex">
                <span className="badge-dot" />
                Get Started Today
              </div>

              <h2
                className="font-syne font-bold"
                style={{ fontSize: "clamp(38px, 5vw, 72px)", color: "#e8eaf0", lineHeight: 1.1 }}
              >
                Build the Future of{" "}
                <span className="grad-text">Financial Interoperability</span>
              </h2>

              <p
                className="text-lg"
                style={{ color: "var(--c-muted)", fontFamily: "'DM Sans', sans-serif" }}
              >
                Let's build the future of Financial Interoperability, together.
              </p>

              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <button
                  onClick={() => navigate("/merchant/signin")}
                  className="px-8 py-4 rounded-full font-syne font-semibold transition-all duration-300"
                  style={{
                    background: "linear-gradient(135deg, #52c6a8, #4f8ef7)",
                    color: "#06080f",
                    boxShadow: "0 0 40px rgba(82,198,168,0.3)",
                    fontSize: "15px",
                  }}
                  onMouseEnter={e => { e.currentTarget.style.boxShadow = "0 0 60px rgba(82,198,168,0.55)"; }}
                  onMouseLeave={e => { e.currentTarget.style.boxShadow = "0 0 40px rgba(82,198,168,0.3)"; }}
                >
                  Get Started — It's Free
                </button>
                <button
                  className="px-8 py-4 rounded-full font-syne font-semibold transition-all duration-300"
                  style={{
                    color: "#e8eaf0",
                    border: "1px solid rgba(255,255,255,0.12)",
                    background: "rgba(255,255,255,0.04)",
                    fontSize: "15px",
                  }}
                >
                  Read Documentation
                </button>
              </div>
            </div>

            {/* Email subscribe */}
            <div className="grad-divider my-16 max-w-xl mx-auto" />

            <div className="max-w-md mx-auto text-center">
              <div
                className="font-syne font-semibold text-white mb-2"
                style={{ fontSize: "15px" }}
              >
                Be the first to know Cahex updates
              </div>
              <div
                className="text-sm mb-5"
                style={{ color: "var(--c-muted)", fontFamily: "'DM Sans', sans-serif" }}
              >
                No spam. Product updates only.
              </div>

              {subscribed ? (
                <div
                  className="px-6 py-3 rounded-xl font-syne font-semibold text-sm"
                  style={{ background: "rgba(82,198,168,0.1)", border: "1px solid rgba(82,198,168,0.3)", color: "#52c6a8" }}
                >
                  ✓ You're subscribed!
                </div>
              ) : (
                <div
                  className="flex gap-2 rounded-xl p-1.5"
                  style={{ background: "rgba(255,255,255,0.04)", border: "1px solid rgba(255,255,255,0.08)" }}
                >
                  <input
                    type="email"
                    placeholder="your@email.com"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    className="flex-1 bg-transparent outline-none px-4 text-sm"
                    style={{ color: "#e8eaf0", fontFamily: "'DM Sans', sans-serif" }}
                    onKeyDown={e => e.key === "Enter" && handleSubscribe()}
                  />
                  <button
                    onClick={handleSubscribe}
                    className="px-5 py-2.5 rounded-lg font-syne font-semibold text-sm transition-all duration-200"
                    style={{
                      background: "linear-gradient(135deg, #52c6a8, #4f8ef7)",
                      color: "#06080f",
                    }}
                  >
                    Subscribe
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>

      <FooterPage />
    </div>
  );
};

export default GetStarted;
